import { ConclusionKeys, FindingAreasEnum, getFindingAreaDisplayText, zodQuestionTypes } from "../surveyStatusSchemas";

const questionnaireOpwPart3 = {
    id: FindingAreasEnum.OffPayrollWorkersAgencyEngagedWorkers,
    name: getFindingAreaDisplayText(FindingAreasEnum.OffPayrollWorkersAgencyEngagedWorkers),
    questions: [
        {
            id: `${FindingAreasEnum.OffPayrollWorkersAgencyEngagedWorkers}:Q5`,
            text: "Do you engage with off payroll workers via an agency?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.OffPayrollWorkersAgencyEngagedWorkers}:Q7A`,
                no: ConclusionKeys.Green,
            },
        },
        {
            id: `${FindingAreasEnum.OffPayrollWorkersAgencyEngagedWorkers}:Q7A`,
            text: "Is the agency based in the UK?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.OffPayrollWorkersAgencyEngagedWorkers}:Q8A`,
                no: `${FindingAreasEnum.OffPayrollWorkersAgencyEngagedWorkers}:Q8B`,
            },
        },
        {
            id: `${FindingAreasEnum.OffPayrollWorkersAgencyEngagedWorkers}:Q8A`,
            text: "Are the workers employed by the agency and on agency payroll subject to income tax and NIC via PAYE?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Green,
                no: `${FindingAreasEnum.OffPayrollWorkersAgencyEngagedWorkers}:Q9A`,
            },
        },
        {
            id: `${FindingAreasEnum.OffPayrollWorkersAgencyEngagedWorkers}:Q8B`,
            text: "Do the underlying workers perform services in the UK?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.OffPayrollWorkersAgencyEngagedWorkers}:Q9A`,
                no: ConclusionKeys.Green,
            },
        },
        {
            id: `${FindingAreasEnum.OffPayrollWorkersAgencyEngagedWorkers}:Q9A`,
            text: "Are the workers employed by you and on your payroll (or agency payroll) subject to income tax and NIC via PAYE?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Green,
                no: `${FindingAreasEnum.OffPayrollWorkersAgencyEngagedWorkers}:Q10`,
            },
        },
        {
            id: `${FindingAreasEnum.OffPayrollWorkersAgencyEngagedWorkers}:Q10`,
            text: "Do you assess the agency worker from an employment status perspective?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Green,
                no: ConclusionKeys.Red
            },
        }
    ],
};

export default questionnaireOpwPart3;
